import { apiService } from './api.service';
import { API_ENDPOINTS } from '../config/api';

export interface Laboratorio {
    idlab: number;
    nombre: string;
    estado: 'Activo' | 'Inactivo';
}

export interface CreateLaboratorioData {
    nombre: string;
    estado: 'Activo' | 'Inactivo';
}

export interface UpdateLaboratorioData extends Partial<CreateLaboratorioData> {
    idlab: number;
}

class LaboratoriosService {
    async getAll(search?: string): Promise<Laboratorio[]> {
        const params = search ? { params: { search } } : undefined;
        const response = await apiService.get<any>(API_ENDPOINTS.LABORATORIOS, true, params);
        return response.data || response;
    }

    async search(query: string): Promise<Laboratorio[]> {
        return apiService.get<Laboratorio[]>(
            `${API_ENDPOINTS.GENERICOS_LABORATORIOS}`,
            true,
            { params: { search: query } }
        );
    }

    async searchFuzzy(query: string): Promise<Laboratorio> {
        return apiService.get<Laboratorio>(
            `${API_ENDPOINTS.LABORATORIOS_FUZZY}?q=${encodeURIComponent(query)}`
        );
    }

    async create(data: CreateLaboratorioData): Promise<Laboratorio> {
        const response = await apiService.post<any>(`${API_ENDPOINTS.LABORATORIOS}/create`, data);
        return response.data || response;
    }

    async update(idlab: number, data: Partial<CreateLaboratorioData>): Promise<Laboratorio> {
        const response = await apiService.put<any>(`${API_ENDPOINTS.LABORATORIOS}/update`, { ...data, idlab });
        return response.data || response;
    }

    async delete(idlab: number): Promise<{ message: string }> {
        return apiService.delete<{ message: string }>(`${API_ENDPOINTS.LABORATORIOS}/delete/${idlab}`);
    }
}

export const laboratoriosService = new LaboratoriosService();
